import { ChipProps } from '@mui/material/Chip/Chip';
import React from 'react';

import { StyledTag } from '@/shared/components/ui/tag/tag.styled';

export const Tag: React.FC<ChipProps> = (props) => {
  return <StyledTag {...props} className="custom-tag" />;
};
